<p-accordion [multiple]="true">
  <p-accordionTab
    header="{{ 'Common.Form.Header' | translate }}"
    [(selected)]="isSearchFormOpen"
  >
    <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
  </p-accordionTab>

  <p-accordionTab
    header="{{ 'ForwarderSetting.LocalRecommendForwarder.FormHeader.DataTable' | translate }}"
    [(selected)]="isDataTableOpen"
  >
    <ng-content *ngTemplateOutlet="settingDataTableTemplate"></ng-content>
  </p-accordionTab>
</p-accordion>

<ng-template #settingSearchFormTemplate>
  <form [ngStyle]="{'height':'100%'}" [formGroup]="searchForm">
    <div class="p-fluid formgrid grid">
      <div class="field col-4">
        <label>{{ 'ForwarderSetting.LocalRecommendForwarder.TableColumn.Forwarder' | translate }}</label>
        <p-multiSelect formControlName="forwarderCodes"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="forwarderOptions"
                [filter]="true"
                filterBy="label">
        </p-multiSelect>
      </div>
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formCity">{{ 'AreaMappingRFQMaintenance.Form.City' | translate }}</label>
        <p-multiSelect
          inputId="formCity"
          placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectOneOrMoreCity' | translate }}"
          display="chip"
          [options]="cityOptions"
          [virtualScroll]="true"
          [itemSize]="40"
          formControlName="citySeqNos"
          (onChange)="onCityChange($event, 'form')"
        >
        </p-multiSelect>
      </div>
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formAssignmentDistrict">{{ 'AreaMappingRFQMaintenance.Form.AssignmentDistrict' | translate }}</label>
        <p-multiSelect
          inputId="formAssignmentDistrict"
          placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectOneOrMoreAssignmentDistrict' | translate }}"
          display="chip"
          [options]="assignmentDistrictIdFormOptions"
          [virtualScroll]="true"
          [itemSize]="40"
          formControlName="assignmentDistrictIds"
        >
        </p-multiSelect>
      </div>
    </div>
    <div class="grid">
      <div class="col">
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn()" class="p-button-secondary p-ml-2"></button>
        <button pButton pRipple label="{{ 'Common.Button.Import' | translate }}" icon="pi pi-upload" (click)="showImportDialog()" class="p-mr-2"></button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #settingDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
      #dataTable
      [loading]="isLoading"
      [dataKey]="'rowId'"
      [tableKey]="preferenceKey"
      [defaultColumns]="columns"
      [value]="dataRows"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [createNewRow]="createNewRow"
      [inputValid]="dataInputValid"
      (createRow)="createRow($event)"
      (savedData)="saveData($event)"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      [selectable]="true"
      [(selectedRows)]="selectedRowsWithCheckBox"
      (onRowSelect)="onRowSelect($event)"
    >
    <ng-template pTemplate="caption">
      <ng-container *ngIf="dataTable.isEdit">
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!dataTable.isInEditMode"
          (click)="deleteBtnClick()"
          class="p-button-danger p-button-raised ml-2">
        </button>
        <button
          pButton
          pRipple
          label="{{ 'Common.Button.Export' | translate }}"
          [disabled]="dataRows.length === 0"
          (click)="exportBtnClick()"
          class="p-ml-2">
        </button>
      </ng-container>
    </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">  <!-- let-expanded="expand" -->
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'citySeqNo'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'forwarderCode'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : forwarderOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'assignmentDistrictId'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : assignmentDistrictIdConvertOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'citySeqNo'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData.citySeqNo ? rowData.citySeqNo : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="cityOptions"
              [(ngModel)]="rowData.citySeqNo"
              (onChange)="onCityChange($event, 'dataTable')"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'assignmentDistrictId'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : assignmentDistrictIdConvertOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="assignmentDistrictIdTableOptions"
              (onChange)="onAssignmentDistrictIdChange($event, rowData)"
              [(ngModel)]="rowData.assignmentDistrictId"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate}}"
              [filter]="true"
              [options]="forwarderOptions"
              filterBy="label,value"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'poolCode'" >
            <div class="overflow-text" *ngIf="isTextType" >
              <div class="formgrid grid">
                <div class="col">
                  <input
                    type="text"
                    pInputText
                    maxlength="255"
                    style="width: 100%;"
                    [(ngModel)]="rowData[col.field]"
                    (onInput)="onInputHandle($event, rowData)"
                  />
                </div>
              </div>
            </div>
            <div class="overflow-text" *ngIf="isDropdownType" >
              <p-dropdown
              appendTo="body"
              class="p-fluid"
              [filter]="true"
              [options]="poolCodeOptions"
              placeholder="{{ rowData.poolCode ? rowData.poolCode : 'Common.Message.ChooseOption' | translate }}"
              filterBy="label,value"
              [(ngModel)]="rowData.poolCode"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'citySeqNo'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:cityOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateUser'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:userOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'assignmentDistrictId'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping:assignmentDistrictIdConvertOptions | replaceNullWith:'-' }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

<p-dialog header="Local貨代批次匯入" [(visible)]="displayImportDialog" [style]="{width: '50vw'}" [modal]="true" [baseZIndex]="100">

  <div *ngIf="isImportDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="p-fluid">
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ForwarderSetting.UploadDailog.ImportFacility' | translate }}</label>
      <p-multiSelect
          [filter]="true"
          [options]="facilityOptions"
          [(ngModel)]="facilityList"
          [appendTo]="'body'"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
      </p-multiSelect>
    </div>
    <div class="flex justify-content-between">
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xls,.xlsx,.xlsm">
      <button pButton pRipple label="{{ 'Common.Button.Select' | translate }}" icon="pi pi-check" class="p-button-success mr-2" (click)="fileInput.click()"></button>
      <button pButton pRipple label="{{ 'Common.Button.FileUpload' | translate }}" icon="pi pi-upload" class="mr-2" (click)="uploadFile()" [disabled]="!isFileSelected"></button>
      <button pButton pRipple label="{{ 'Common.Button.DownloadTemplate' | translate }}" icon="pi pi-download" class="p-button-secondary" (click)="downloadTemplateBtn()"></button>
    </div>

    <div *ngIf="isFileSelected" class="mt-3">
      File: {{ selectedFileName }}
    </div>
  </div>
</p-dialog>


